import { Youtube, Instagram, Linkedin, Mail, Facebook } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import { SupportButtons } from "@/components/SupportButtons";
import { SOCIAL } from "@/config/social";

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-secondary text-secondary-foreground py-16">
      <div className="container mx-auto px-4">
        <div className="max-w-6xl mx-auto">
          <div className="grid gap-10 md:gap-x-12 lg:gap-x-16 gap-y-12 mb-12 md:[grid-template-columns:1fr_auto_1fr] md:items-stretch">
            <div className="md:justify-self-start md:text-left md:h-full">
              <h3 className="font-display text-2xl font-bold text-accent leading-tight mb-4 whitespace-nowrap">
                Rob Lasa
              </h3>
              <nav aria-label="Footer">
              <ul role="list" className="space-y-2 text-secondary-foreground/80 leading-relaxed whitespace-nowrap">
                <li>
                  <Link to="/about" className="hover:text-accent transition-colors">
                    About
                  </Link>
                </li>
                <li>
                  <Link to="/journal" className="hover:text-accent transition-colors">
                    Journal
                  </Link>
                </li>
                <li>
                  <Link to="/nice-guy" className="hover:text-accent transition-colors">
                    The Nice Guy Trap
                  </Link>
                </li>
                <li>
                  <Link to="/nice-guy-assessment" className="hover:text-accent transition-colors">
                    Assessment
                  </Link>
                </li>
              </ul>
              </nav>
            </div>

            <div
              id="support-donations"
              tabIndex={-1}
              className="space-y-4 md:justify-self-center md:text-center md:items-center flex flex-col md:h-full scroll-mt-24 focus:outline-none"
            >
              <h4 className="font-semibold text-lg text-secondary-foreground">
                Support
              </h4>
              <p className="text-sm text-secondary-foreground/80">
                If something here landed, you can buy me a coffee.
              </p>
              <SupportButtons variant="compact" />
              <p className="text-sm text-secondary-foreground/80 pt-1">
                <a
                  href="https://venmo.com/u/roblasa"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:text-accent transition-colors underline-offset-2 hover:underline"
                >
                  Venmo: @roblasa
                </a>
                <span className="px-2 text-secondary-foreground/50">|</span>
                <a
                  href="https://paypal.me/roblasa"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:text-accent transition-colors underline-offset-2 hover:underline"
                >
                  PayPal.me: roblasa
                </a>
              </p>
            </div>

            <div className="space-y-4 md:justify-self-end md:text-right md:items-end flex flex-col md:h-full">
              <h4 className="font-semibold text-lg text-secondary-foreground">
                Connect
              </h4>
              <div className="flex gap-3">
                <Button size="icon" variant="outline" asChild className="bg-transparent border-secondary-foreground/30 hover:bg-[#FF0000] hover:border-[#FF0000] hover:text-white">
                  <a href={SOCIAL.youtube.channelUrl} target="_blank" rel="noopener noreferrer" aria-label="YouTube (opens in a new tab)">
                    <Youtube className="w-5 h-5" />
                    <span className="sr-only"> (opens in a new tab)</span>
                  </a>
                </Button>
                <Button size="icon" variant="outline" asChild className="bg-transparent border-secondary-foreground/30 hover:bg-accent hover:border-accent">
                  <a href={SOCIAL.facebook.profileUrl} target="_blank" rel="noopener noreferrer" aria-label="Facebook (opens in a new tab)">
                    <Facebook className="w-5 h-5" />
                    <span className="sr-only"> (opens in a new tab)</span>
                  </a>
                </Button>
                <Button size="icon" variant="outline" asChild className="bg-transparent border-secondary-foreground/30 hover:bg-accent hover:border-accent">
                  <a href={SOCIAL.instagram.profileUrl} target="_blank" rel="noopener noreferrer" aria-label="Instagram (opens in a new tab)">
                    <Instagram className="w-5 h-5" />
                    <span className="sr-only"> (opens in a new tab)</span>
                  </a>
                </Button>
                <Button size="icon" variant="outline" asChild className="bg-transparent border-secondary-foreground/30 hover:bg-accent hover:border-accent">
                  <a href={SOCIAL.linkedin.profileUrl} target="_blank" rel="noopener noreferrer" aria-label="LinkedIn (opens in a new tab)">
                    <Linkedin className="w-5 h-5" />
                    <span className="sr-only"> (opens in a new tab)</span>
                  </a>
                </Button>
                <Button size="icon" variant="outline" asChild className="bg-transparent border-secondary-foreground/30 hover:bg-accent hover:border-accent">
                  <a href="mailto:rob@souldadrob.com" aria-label="Email">
                    <Mail className="w-5 h-5" />
                  </a>
                </Button>
              </div>
              <Link to="/connect" className="text-sm text-secondary-foreground/80 hover:text-accent transition-colors inline-block">
                Get in Touch →
              </Link>
            </div>
          </div>

          <div className="border-t border-secondary-foreground/20 pt-8">
            <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-secondary-foreground/70 text-sm">
              <p>© {currentYear} Rob Lasa. All Rights Reserved.</p>
              <div className="flex gap-6">
                <a href="#" className="hover:text-accent transition-colors">Privacy Policy</a>
                <a href="#" className="hover:text-accent transition-colors">Terms of Service</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};
